{
  "PHONE_CTRLS": {
    "EXTENSION_BANNER": {
      "TEXT": "Chrome-laajennusta ei ole asennettu.",
      "CTA": "Asenna laajennus"
    },
    "TABS": {
      "PHONE": "Puhelin",
      "SMS": "SMS",
      "HISTORY": "Historia"
    },
    "HISTORY": {
      "OPEN": "Avaa",
      "RECENT": "Viimeisimmät",
      "MISSED": "Vastaamattomat",
      "LOADING": "Ladataan puheluita...",
      "EMPTY": "Ei puheluita",
      "ERROR": "Puheluita ei voitu ladata",
      "CALL": "Soita takaisin",
      "CALL_STATUS": {
        "BUTTON": "Aseta puhelun tila",
        "TITLE": "Puhelun tila",
        "SEARCH_PLACEHOLDER": "Etsi tiloja...",
        "LOADING": "Ladataan tiloja...",
        "NO_OPTIONS": "Puhelun tiloja ei ole määritetty",
        "NO_MATCH": "Ei vastaavaa tilaa",
        "OPTIONS_ERROR": "Tiloja ei voitu ladata",
        "RETRY": "Yritä uudelleen",
        "CONFIRM_QUESTION": "Haluatko asettaa tilaksi ”{status}” ja ratkaista keskustelun?",
        "CONFIRM": "Vahvista",
        "BACK": "Takaisin",
        "CANCEL": "Peruuta",
        "SAVING": "Tallennetaan...",
        "SAVE_ERROR": "Tilaa ei voitu tallentaa",
        "RESOLVE_ERROR": "Tila tallennettu, mutta keskustelua ei voitu ratkaista"
      }
    },
    "SMS": {
      "NUMBER_PLACEHOLDER": "Puhelinnumero, esim. +421903000000",
      "BODY_PLACEHOLDER": "Kirjoita viestisi...",
      "SEGMENTS": "({segments} SMS)",
      "SEND": "Lähetä tekstiviesti",
      "SENDING": "Lähetetään...",
      "SENT": "Tekstiviesti lähetetty",
      "LOADING": "Ladataan tekstiviestikansioita...",
      "NO_INBOX": "Tällä tilillä ei ole tekstiviestikansiota, joten tekstiviestiä ei voi lähettää.",
      "INVALID_NUMBER": "Anna numero kansainvälisessä muodossa, myös alun + merkki.",
      "ERROR": "Tekstiviestin lähetys epäonnistui. Yritä uudelleen."
    },
    "ACTIONS": {
      "CONNECT": "Yhdistä",
      "GO_TO_TAB": "Siirry kyseiseen välilehteen",
      "DISCONNECT": "Katkaise yhteys",
      "ANSWER": "Vastaa",
      "HANGUP": "Lopeta puhelu",
      "HOLD": "Pito",
      "MUTE": "Mykistä mikrofoni",
      "SILENCE": "Mykistä ääni",
      "TRANSFER": "Siirrä",
      "COMPLETE_TRANSFER": "Viimeistele siirto",
      "RETURN_TO_CALLER": "Palaa soittajan luo",
      "CANCEL_TRANSFER": "Peruuta siirto",
      "DIALPAD": "Näytä valintanäppäimistö",
      "OPEN_CONVERSATION": "Avaa keskustelu"
    },
    "NOTIFICATIONS": {
      "INCOMING_CALL": "Saapuva puhelu",
      "INCOMING_CALL_FROM": "Saapuva puhelu: {name} ({number})",
      "INCOMING_CALL_FROM_NUMBER": "Saapuva puhelu: {number}",
      "ANSWER": "Vastaa",
      "DECLINE": "Hylkää"
    },
    "TRANSFER": {
      "TITLE": "Siirrä puhelu",
      "PLACEHOLDER": "Anna siirron kohdenumero...",
      "SEARCH_PLACEHOLDER": "Etsi kollegoita...",
      "TARGET_PLACEHOLDER": "Valittu siirron kohde",
      "CONFIRM": "Siirrä",
      "MODE_DIRECT": "Siirrä nyt",
      "MODE_CONSULT": "Soita kollegalle ensin",
      "CANCEL": "Peruuta"
    },
    "QUEUE_BREAK": {
      "CONFIRM_BREAK": "Haluatko varmasti mennä tauolle kaikissa jonoissa?",
      "CONFIRM_READY": "Haluatko varmasti palata valmiustilaan kaikissa jonoissa?",
      "CONFIRM_BREAK_QUEUE": "Haluatko varmasti kirjautua ulos jonosta {queue}?",
      "CONFIRM_READY_QUEUE": "Haluatko varmasti kirjautua jonoon {queue}?",
      "LOGIN_TO_QUEUE": "Kirjaudu sisään",
      "LOGOUT_FROM_QUEUE": "Kirjaudu ulos",
      "LOGIN_TO_ALL_QUEUES": "Kirjaudu kaikkiin jonoihin",
      "LOGOUT_FROM_ALL_QUEUES": "Kirjaudu ulos kaikista jonoista",
      "OPTION_LOGOUT": "Kirjaudu ulos",
      "OPTION_BREAK": "Tauko",
      "OPTION_LUNCH": "Lounas",
      "OPTION_AWAY": "Poissa",
      "OPTION_DO_NOT_DISTURB": "Älä häiritse",
      "OPTION_BUSINESS_TRIP": "Työmatka",
      "CONFIRM": "Vahvista",
      "CANCEL": "Peruuta"
    },
    "CONNECTION_ERROR": {
      "TITLE": "Ei yhteyttä puhelinjärjestelmään",
      "MESSAGE": "Internetyhteytesi vaikuttaa olevan poikki. Tarkista yhteys ja yritä uudelleen.",
      "CREDENTIALS_TITLE": "Puhelinjärjestelmä hylkäsi kirjautumistietosi",
      "CREDENTIALS_MESSAGE": "Puhelinjärjestelmä hylkäsi profiiliisi tallennetun käyttäjätunnuksen tai salasanan. Tarkista ne Profiilin asetuksista tai ota yhteyttä pääkäyttäjään.",
      "CONFIGURATION_TITLE": "Puhelimen asetukset eivät ole kelvolliset",
      "CONFIGURATION_MESSAGE": "SIP-käyttäjätunnus tai palvelimen osoite ei ole kelvollisessa muodossa, joten puhelin ei voi muodostaa yhteyttä. Korjaa se Profiilin asetuksissa.",
      "NETWORK_SHORT": "Yhteys epäonnistui",
      "CREDENTIALS_SHORT": "Kirjautumistiedot hylätty",
      "CONFIGURATION_SHORT": "Virheelliset puhelinasetukset",
      "RETRY": "Yritä uudelleen",
      "DISMISS": "Peruuta"
    },
    "CONNECTION_QUALITY": "Yhteyden laatu",
    "CONNECTION_QUALITY_EXCELLENT": "Erinomainen",
    "CONNECTION_QUALITY_GOOD": "Hyvä",
    "CONNECTION_QUALITY_FAIR": "Kohtalainen",
    "CONNECTION_QUALITY_POOR": "Heikko",
    "CONNECTION_QUALITY_DISCONNECTED": "Ei yhteyttä",
    "STATUS": {
      "OFFLINE": "Puhelin offline",
      "IN_OTHER_TAB": "Puhelin on yhteydessä toisessa välilehdessä",
      "CONNECTING": "Yhdistetään...",
      "DISCONNECTING": "Katkaistaan yhteyttä...",
      "ONLINE": "Puhelin online",
      "DIALING": "Soitetaan",
      "TRANSFERRING": "Siirretään...",
      "CONSULTING": "Puhuu kollegan kanssa",
      "CALLER_ON_HOLD": "Soittaja on pidossa",
      "BUSY": "Varattu",
      "DND": "DND",
      "UNAVAILABLE": "Ei tavoitettavissa",
      "REJECTED": "Puhelu hylätty",
      "CALL_FAILED": "Puhelu epäonnistui"
    },
    "QUEUES": {
      "MORE": "Lisää jonoja"
    }
  },
  "DIAL_REDIRECT": {
    "DIALING": "Soitetaan numeroon {number}… Voit sulkea tämän välilehden.",
    "NO_NUMBER": "Numeroa ei annettu. Käytä ?number=+420..."
  },
  "PHONE_DIAL": {
    "PLACEHOLDER": "Anna puhelinnumero...",
    "ACTIONS": {
      "DIAL": "Soita numeroon",
      "DIAL_FROM": "Valitse numero, josta soitat"
    },
    "DIAL_FROM": {
      "TITLE": "Soita saapuneet-kansion numerosta"
    },
    "VALIDATION": {
      "REQUIRED": "Puhelinnumero on pakollinen",
      "INVALID_FORMAT": "Virheellinen puhelinnumeron muoto"
    }
  },
  "PHONE_AUDIO": {
    "TITLE": "Äänen asetukset ja testaus",
    "SELECT_DEVICE": "Valitse laite...",
    "SYSTEM_DEFAULT": "Järjestelmän oletus",
    "SAVED": "Tallennettu",
    "DISCONNECTED_SUFFIX": "ei yhdistetty",
    "DEVICE_DISCONNECTED": "Valittua laitetta ei ole yhdistetty. Puhelut käyttävät järjestelmän oletuslaitetta, kunnes se on taas käytettävissä.",
    "MICROPHONE": {
      "TITLE": "Mikrofoni",
      "START_TEST": "Testaa mikrofonia",
      "STOP_TEST": "Lopeta testi",
      "LEVEL": "Taso:",
      "VERDICT": {
        "LISTENING": "Sano jotain mikrofoniin…",
        "SILENT": "Sinua ei kuulu. Tarkista, että mikrofoni on päällä ja oikea mikrofoni on valittuna.",
        "LOW": "Sinua kuuluu vain hiljaa. Valitse toinen mikrofoni tai säädä sisääntulon äänenvoimakkuutta järjestelmän asetuksista.",
        "GOOD": "Hyvä ääni — sinua kuuluu selvästi."
      }
    },
    "SPEAKER": {
      "TITLE": "Kaiutin",
      "TEST": "Testaa kaiutinta",
      "TESTING": "Testataan...",
      "VOLUME": "Äänenvoimakkuus:",
      "USING_DEFAULT": "Valittu lähtölaite ei ole käytettävissä — ääni toistettiin järjestelmän oletuslaitteella."
    },
    "DONE": "Valmis",
    "ERRORS": {
      "MICROPHONE_ACCESS": "Virhe käytettäessä mikrofonia. Tarkista käyttöoikeudet.",
      "MICROPHONE_PERMISSION_DENIED": "Mikrofonin käyttö on estetty. Salli se selaimesi sivustoasetuksista käyttääksesi puhelinta.",
      "MICROPHONE_SILENT": "Mikrofonisi ei havaitse ääntä. Tarkista äänen asetukset.",
      "EXTENSION_REQUIRED": "Puhelinlaajennusta ei havaittu. Asenna tai ota se käyttöön käyttääksesi mikrofonia.",
      "SPEAKER_TEST": "Virhe testattaessa kaiuttimen toistoa."
    }
  },
  "PHONE_STATUS": {
    "OFFLINE": "Offline",
    "ONLINE": "Online",
    "BUSY": "Varattu"
  },
  "QUEUE_STATUS": {
    "READY": "Valmis",
    "NOT_READY": "Ei vastaanota puheluita",
    "WRAP_UP": "Jälkikäsittely",
    "BREAK": "Tauko",
    "LUNCH": "Lounas",
    "AWAY": "Poissa",
    "DO_NOT_DISTURB": "Älä häiritse",
    "BUSINESS_TRIP": "Työmatka",
    "OTHER_CALL": "Muu puhelu",
    "QUEUE_CALL": "Jonopuhelu",
    "OFFLINE": "Offline",
    "ONLINE": "Online",
    "NO_ACCESS": "Ei puhelinta",
    "PARTIALLY_READY": "Osittain valmis",
    "MIXED": "Sekalainen",
    "CHAT_ONLINE": "Online (chat)",
    "CHAT_BUSY": "Varattu (chat)",
    "CHAT_OFFLINE": "Offline (chat)"
  }
}
